package core.model

const val TICKS_IN_BEAT = 480
const val TICKS_IN_FULL_NOTE = TICKS_IN_BEAT * 4
const val KEY_IN_OCTAVE = 12
const val DEFAULT_LYRIC = "あ"
const val DEFAULT_BPM = 120.0
const val DEFAULT_METER_HIGH = 4
const val DEFAULT_METER_LOW = 4
const val DEFAULT_KEY = 60
const val KEY_CENTER_C = 60.0
const val LOG_FRQ_CENTER_C = 5.566914341
const val LOG_FRQ_DIFF_ONE_KEY = 0.05776226505
